import { backendPy } from "System/system";
import store from "System/reduxStore";

const getMode = () => store.getState().data.useNumba ? "numba" : "pandas";

// -------------------------------------------------------
// -------------------------------------------------------
export const getDocTypesAndCurrencies = async (cb) => {
  const { id, datapath } = store.getState().project;
  const result = await backendPy("invoice", "get_doctypes_and_currencies", {
    projectid: id,
    datapath,
  });
  cb(result.data);
};

// -------------------------------------------------------
// -------------------------------------------------------
export const calculateInvoiceData = cb => async (dispatch) => {
  const { id, datapath, calcParams, parameters } = store.getState().project;
  const invoiceParams = calcParams?.invoiceEligibility || {};
  await backendPy("invoice", "calculate", {
    projectid: id,
    datapath,
    reference_date: parameters?.referenceDate || "",
    calcParamsString: JSON.stringify(invoiceParams),
    mode: getMode(),
  });
  dispatch({type: "SET_INVOICE_CALCULATED"});
  await dispatch(getInvoiceData( () => {}));
  cb();
};

// -------------------------------------------------------
// -------------------------------------------------------
export const getInvoiceData = (cb) => async (dispatch) => {
  const { id, datapath } = store.getState().project;
  const result = await backendPy("invoice", "read", {
    projectid: id, datapath,
  });
  if(result.data) {
    dispatch({type: "SET_INVOICE_DATA", invoice: result.data});
  }
  cb();
};